(function(){
  var klMap = {
    'formModalRetail': 'UQXiEZ',
    'formModalHosteleria': 'Srjn7M',
    'formModalEmpresa': 'RLVZ9q',
    'formModalDeporte': 'T6wjDW',
    'formModalEventos': 'SHD2KW',
    'formModalRegalos': 'XNmTkA'
  };

  function init(){
    // Saca cada modal propio de donde esté escrito y lo cuelga directo de <body>,
    document.querySelectorAll('.bta-modal-overlay').forEach(function(m){
      if (m.parentElement !== document.body) {
        document.body.appendChild(m);
      }
    });

    function openModal(id){
      var modal = document.getElementById(id);
      if(!modal) return;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeModal(modal){
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
    function openKlaviyoForm(formId){
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    document.querySelectorAll('[data-open-form]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var key = btn.getAttribute('data-open-form');
        var modal = document.getElementById(key);
        if (modal) {
          // Prioridad 1: si existe un modal propio con ese id, se abre ese.
          openModal(key);
        } else if (klMap[key]) {
          // Prioridad 2: si no hay modal propio pero el id está mapeado a Klaviyo, se abre ese formulario.
          openKlaviyoForm(klMap[key]);
        }
      });
    });

    document.querySelectorAll('.bta-modal-overlay').forEach(function(modal){
      modal.querySelectorAll('[data-close-form]').forEach(function(btn){
        btn.addEventListener('click', function(){ closeModal(modal); });
      });
      modal.addEventListener('click', function(e){
        if(e.target === modal) closeModal(modal);
      });
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        document.querySelectorAll('.bta-modal-overlay.open').forEach(closeModal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();